import LogoOriginal from './assets/logo/kinedu_educators_color.png';
import LogoAlternative from './assets/logo/kinedu_educators_white_2.png';
import LogoLegionarios from './assets/images/Legionarios/icons/site-logo.svg';

import styled from 'styled-components';
import { Breakpoints } from 'kinedu-react-components';

const checkLogo = (altVersion, languageVersion, project) => {
  if (languageVersion === 'pt') {
    return LogoAlternative;
  }
  if (project === 'semperaltius') {
    return LogoLegionarios;
  }

  return altVersion ? LogoAlternative : LogoOriginal;
};

const ClassroomsLogo = styled.img.attrs(({ altVersion, languageVersion, project }) => ({
  src: checkLogo(altVersion, languageVersion, project),
}))`
  width: 230px;
  height: auto;

  ${Breakpoints.desktop} {
    width: 400px;
    grid-column: 2 / 5;
  }
`;

export default ClassroomsLogo;
